exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.detail-buttons[data-v-28361f28] {\n    margin-bottom: 15px;\n    float: right;\n}\n.add_address[data-v-28361f28] {\n    margin-top: 15px;\n    margin-bottom: 15px;\n}\n.action_icon[data-v-28361f28] {\n    cursor: pointer;\n    margin-right: 5px;\n}\n.tabs[data-v-28361f28], .addresses[data-v-28361f28] {\n    margin-top: 10px;\n}\n.address_block a[data-v-28361f28]{\n    margin-right: 10px;\n}\n", ""]);

// exports
